<template>
  <div class="kt-header__topbar">
    <search-dialog />
    <user-switcher-dialog v-if="isCurrentUserSuperAdmin" />
    <top-notification />
    <top-user />
  </div>
</template>
<script>
import { some as _some } from 'lodash-es';
import SearchDialog from '@/components/partials/_header/SearchDialog.vue';
import UserSwitcherDialog from '@/components/partials/_header/UserSwitcherDialog.vue';
import TopUser from './TopUser.vue';
import TopNotification from './TopNotification.vue';

export default {
  name: 'TopBase',
  components: {
    UserSwitcherDialog,
    SearchDialog,
    TopUser,
    TopNotification,
  },
  created() {
    this.setProfile(this.$auth.user());
  },
  computed: {
    roles() {
      return this.$auth.user().roles;
    },
    isCurrentUserSuperAdmin() {
      return _some(this.roles, { name: 'super-administrator' });
    },
  },
  methods: {
    setProfile(profile) {
      this.$store.commit('profile/setProfile', {
        id: profile.id,
        name: profile.name,
        email: profile.email,
        profilePicture: profile.profile_picture,
        jobTitle: profile.job_title,
        phone: profile.phone_number,
      });
      this.$store.commit('profile/setCompany', profile.dealer);
    },
  },
};
</script>
